import { TradeOrderSideEnum } from '@sparling/financial-common'
import { capitalize } from 'lodash'

const orderSide = []

// eslint-disable-next-line guard-for-in,no-restricted-syntax
for (const side in TradeOrderSideEnum) {
  orderSide.push({
    value: side as TradeOrderSideEnum,
    label: capitalize(TradeOrderSideEnum[side as keyof typeof TradeOrderSideEnum]),
  })
}

export const ORDER_SIDE = [
  {
    value: TradeOrderSideEnum.BUY,
    label: capitalize(TradeOrderSideEnum.BUY),
  },
  {
    value: TradeOrderSideEnum.SELL,
    label: capitalize(TradeOrderSideEnum.SELL),
  },
]
